import React, {useEffect, useState} from 'react';
import {DatePicker, Select, Switch, Tooltip} from "antd";
import {Line} from "@ant-design/plots";
import {API_PATH} from "../../components/const";
import dayjs from "dayjs";
import axios from "axios";
import {toast} from "react-toastify";
import moment from "moment/moment";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import * as XLSX from "xlsx";

const dateFormat = 'YYYY-MM-DD';
const {RangePicker} = DatePicker;

const VisitorsComparasionDateGr = (props) => {
    const [time, setTime] = useState(new Date());
    const [month, setMonth] = useState(time.getMonth());
    const [year, setYear] = useState(time.getFullYear());
    const [data, setData] = useState([]);
    const [data2, setData2] = useState([]);
    const [offices, setOffices] = useState([])
    const [sendData, setSendData] = useState(null)
    const [companies, setCompanies] = useState([])
    const [show, setShow] = useState(false)
    const [parents, setParents] = useState([])
    const [filCameraList, setFilCameraList] = useState([])
    const [filSelectCamera, setSelectFilCamera] = useState([])
    const [date1, setdate1] = useState("")
    const [date11, setdate11] = useState("")
    const [date2, setdate2] = useState("")
    const [date22, setdate22] = useState("")

    function roundToTwoDecimals(num) {
        return Math.round(num * 100) / 100;
    }
    const exportToExcel = () => {
        console.log(data2)
        // Ma'lumotlarni formatlash
        const formattedData = data2.map((item, index) => ({
            "Дата": item?.interval,
            "Единство (1)": item["1"],
            "Двойной (2)": item["2"],
            "Три (3)": item["3"],
            "Четыре (4) ": item["4"],
            "Пять (5)":  item["5"],
            "другой": item["other"],
        }));

        // Jadvalni Excel formatiga aylantirish
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "TableData");

        // Faylni saqlash
        XLSX.writeFile(workbook, "table_data.xlsx");
    };

    function transformData(data) {
        const result = [];

        // Ma'lumotlarni interval bo'yicha guruhlash
        data.forEach((item) => {
            let existing = result.find((row) => row.interval === item.interval);

            if (!existing) {
                // Agar interval mavjud bo'lmasa, yangi obyekt qo'shamiz
                existing = { interval: item.interval, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, other: 0 };
                result.push(existing);
            }

            // Type bo'yicha qiymatni to'g'ri joylashtirish
            if (item.type >= 1 && item.type <= 5) {
                existing[item.type] += item.value;
            } else {
                existing.other += item.value;
            }
        });

        return result;
    }


    function onChange(date, dateString) {

        console.log(dateString)
        setdate1(dateString)
    }

    function onChange2(date, dateString) {

        console.log(date)
        setdate2(dateString)

    }

    const asyncFetch = (data) => {
        if (date1?.length > 0  && date2?.length > 0  ) {
            // https://apis.cradle-vision.com/company/213/analytics/group-visitors/report?start_date=sad&end_date=123&granularity=hourly&smart_camera_ids=213&group_sizes=1&report_format=json

                axios.get(API_PATH + "analytics/company/" + localStorage.getItem('id') + "/analytics/group-visitors/report?start_date=" + date1 + "&end_date=" + date2  + "&granularity=daily&group_sizes=1,2,3,4,5+&report_format=json", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then((json) => {
                        setData(json?.data)
                        setData2(transformData(json?.data))
                    }
                )
                .catch(() => {
                });

        } else {
            toast.error("Заполните поле")

        }


    };
    const onSwitch = () => {
        setShow(!show)
        asyncFetch()
    }

    const config = {
        data,
        xField: 'interval',
        yField:  'value',
        seriesField: 'type',
        label: {
            style: {
                fill: 'white',
            },
        },
        // point: {
        //     size: 5,
        //     shape: 'diamond',
        //     style: {
        //         fill: 'white',
        //         stroke: '#5B8FF9',
        //         lineWidth: 2,
        //     },
        // },

        interactions: [
            {
                type: 'marker-active',
            },
        ],
        legend: {
            position: 'top',
        },

        style: {
            lineWidth: 2,

        },
        smooth: true,
    };

    // const config = {
    //
    //     data,
    //     xField: 'interval',
    //     yField: 'value',
    //
    //     sizeField: 'type',
    //     point: {
    //         shapeField: 'square',
    //         sizeField: 1,
    //         style: {
    //             fill: 'white',
    //             stroke: '#5B8FF9',
    //             lineWidth: 2,
    //         },
    //     },
    //     interaction: {
    //         tooltip: {
    //             marker: false,
    //         },
    //     },
    //     style: {
    //         lineWidth: 2,
    //     },
    //
    // };
    const config2 = {


        data,
        xField: 'date_interval_2',
        yField: 'value_2',
        point: {
            shapeField: 'square',
            sizeField: 4,
            style: {
                fill: 'white',
                stroke: '#ff4d4f',
                lineWidth: 2,
            },
        },
        interaction: {
            tooltip: {
                marker: false,
            },
        },
        style: {
            lineWidth: 2,
        },
        lineStyle: {
            stroke: '#ff4d4f',
            lineWidth: 2,
        },
    };

    useEffect(() => {
        // getBuilding()
        // getParentBuilding()
        // getFilCamera()

        setCompanies(localStorage.getItem("com1data")?.split(',').map(Number))
    }, [show]);
    return (
        <div>
            <div className="visitor visitor-box">
                <div className="chart-box">
                    <div className="visitor-title">
                        <h1>
                            <span className="font-family-medium">
                            Группа посетителей ежедневно
                        </span>

                            <div className="d-flex align-items-center my-multi-select">


                                <div className="inputs-box mr-24 remove-back-select" style={{marginTop: "-7px"}}>
                                    <Select
                                        showSearch
                                        placeholder="Выберите тип"
                                        optionFilterProp="children"
                                        className="w-100"
                                        value={props?.seldate}
                                        onChange={(e) => props.setseldate(e)}
                                        options={props.selList?.map((item) => {
                                            return {
                                                value: item.value,
                                                label:
                                                item?.name
                                            };
                                        })}
                                    />
                                </div>


                                <div className="mr-24 d-flex align-items-center">


                                    <DatePicker
                                        placeholder="Фильтр даты"
                                        defaultValue={dayjs(time)}
                                        onChange={onChange}/>


                                    <h4 className="text-white mb-0 ml-8 mr-8">-</h4>


                                    <DatePicker
                                        placeholder="Фильтр даты"
                                        defaultValue={dayjs(time)}
                                        onChange={onChange2}/>



                                </div>
                                <button style={{fontSize: "14px"}} onClick={asyncFetch}
                                        className="ml-16 mt-2 add-btn">Сравнивать
                                </button>
                            </div>


                        </h1>
                    </div>
                    <div className="d-flex w-100">
                        <div className="w-100 p-3">
                            <Line {...config} />
                        </div>
                        {/*<div className="w-100 p-3">*/}
                        {/*    <Line {...config2} />*/}

                        {/*</div>*/}
                    </div>

                    {
                        data2?.length > 0
                            ?
                            <div className="emp-table mt-4 ">
                                <div className="d-flex justify-content-between">
                                    <button type="submit" className="add-btn mb-3" onClick={() => setShow(!show)}>Посмотреть таблицу</button>
                                    <button type="submit" className="btn btn-success mb-3" onClick={exportToExcel}>Скачать таблицу</button>
                                </div>
                                {
                                    show
                                        ?
                                        <TableContainer component={Paper}>
                                            <Table sx={{minWidth: 650}} aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className="pl20 table-head">№</TableCell>
                                                        <TableCell className="  table-head">Дата</TableCell>
                                                        <TableCell className="table-head" >1</TableCell>
                                                        <TableCell className="table-head" >2</TableCell>
                                                        <TableCell className="table-head" >3</TableCell>
                                                        <TableCell className="table-head" > 4</TableCell>
                                                        <TableCell className="table-head" > 5</TableCell>
                                                        {/*<TableCell className="table-head"  align="left">25.12.2023</TableCell>*/}
                                                        <TableCell className="table-head" >другой</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {data2.map((item, index) => (
                                                        <TableRow
                                                            key={item?.name}
                                                            sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                                        >
                                                            <TableCell className="pl20" scope="row">
                                                                <div className="tabel-item">
                                                                    {index + 1}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell  scope="row">
                                                                <div className="tabel-item">
                                                                    {item?.interval}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className="pl20" scope="row">
                                                                <div className="tabel-item">
                                                                    {item["1"]}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell >
                                                                <div className="tabel-item">
                                                                    {item["2"]}
                                                                </div>
                                                            </TableCell>

                                                            <TableCell >
                                                                <div className="tabel-item">
                                                                    {item["3"]}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell >
                                                                <div className="tabel-item">
                                                                    {item["4"]}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell >
                                                                <div className="tabel-item">
                                                                    {item["5"]}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell  >
                                                                <div className="tabel-item">
                                                                    {item["other"]}
                                                                </div>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                        :
                                        ""
                                }

                            </div>
                            :
                            ""
                    }

                </div>
            </div>
        </div>
    );
};

export default VisitorsComparasionDateGr;